import { OfferDisplayCategoriesInput, OfferFragment } from '@occc/graphql';

export class DisplayCategoriesDuplicationService {
  public copy(
    displayCategories: OfferFragment['displayCategories'],
    offerId: string,
  ): OfferDisplayCategoriesInput {
    return {
      displayCategoriesIds: displayCategories?.map((category) => category.id),
      offerId,
    };
  }
}

export const displayCategoriesDuplicationService = new DisplayCategoriesDuplicationService();
